import React, { Component } from "react";
import "./css/Footer.css";

export default class Footer extends Component {
  open = () => {
    window.open("https://www.battlerite.com");
  };
  render() {
    return (
      <div className="footerContainer">
        <div className="bottom_wide" onClick={this.open}>
          <p>BATTLERITE.COM</p>
        </div>
        <div>
          <div className="footerImages">
            <img
              className="company1"
              src="https://cdn.battlerite.com/www3/images/static/new_era2/SLS_logo.png"
              alt="stunlock_studios_logo"
              onClick={() => (window.location.href = "https://stunlock.com")}
            />
            <img
              className="company2"
              src="https://cdn.battlerite.com/www3/images/static/new_era2/cs_logotype_white.png"
              alt="coffestain_logo"
              onClick={() =>
                (window.location.href = "https://www.coffeestainstudios.com/")
              }
            />
          </div>
          <p>© Stunlock Studios. All Rights Reserved. </p>
        </div>
      </div>
    );
  }
}
